export default __webpack_public_path__ + "static/media/mobilesyrup.db6eb1c6.png";